'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useAI } from '@/context/AIContext'
import { SplitScreenManager } from './SplitScreenManager'

// ============================================================================
// AI Manager Component
// ============================================================================

export function AIManager() {
  const {
    isManagerOpen,
    closeManager,
  } = useAI()
  
  const [mounted, setMounted] = useState(false)

  // Only mount on client side to prevent hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])

  // Handle escape key to close
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isManagerOpen) {
        closeManager()
      }
    }
    
    if (isManagerOpen) {
      document.addEventListener('keydown', handleKeyDown)
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden'
    }
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [isManagerOpen, closeManager])

  // Only render after client-side mount to prevent hydration issues
  if (!mounted) return null

  return createPortal(
    <SplitScreenManager />,
    document.body
  )
}
